import React, { Component } from "react";
import { Tag, Thumbnail, Tooltip } from "@culturehq/components";

import { useProfile } from "app/context";
import { ProfileLink } from "app/links";
import { t, Trans } from "app/utils";

import { Time } from "components/common/Time";
import ErrorModal from "components/display/ErrorModal";
import getUserName from "app/utils/getUserName";

const UserStatus = ({ user }) => {
  if (!user.active) {
    return t("Disabled");
  }

  if (user.claimed) {
    return t("Enabled");
  }

  if (!user.inviteExpiresAt || (new Date() > new Date(user.inviteExpiresAt))) {
    return (
      <Tooltip tip={t("For security purposes, users have seven days to create an account before their invite must be resent.")}>
        <Trans>Invite Expired</Trans>
      </Tooltip>
    );
  }

  return (
    <Tooltip tip={t("For security purposes, users have seven days to create an account before their invite must be resent.")}>
      <Trans>Invite Pending</Trans>
      <br />
      Expires <Time time={user.inviteExpiresAt} format="%b %e" />
    </Tooltip>
  );
};

class UserRowContext extends Component {
  state = {
    error: null
  };

  handleErrorModalClose = () => {
    this.setState({ error: null });
  };

  render() {
    const { user } = this.props;
    const { error } = this.state;

    return (
      <>
        <tr className={user.active ? "enabled" : "disabled"}>
          <td>
            <Thumbnail image={user.avatar.thumbUrl} title={getUserName(user)} />
            <ErrorModal error={error} onClose={this.handleErrorModalClose} />
          </td>
          <td>
            <ProfileLink user={user} />
            {!user.active && (
              <>
                {" "}<Tag color="gray"><Trans>Disabled</Trans></Tag>
              </>
            )}
            {user.organizationAdmin && (
              <>
                {" "}<Tag color="blue"><Trans>Admin</Trans></Tag>
              </>
            )}
            <br />
            {user.email}
          </td>
          <td>{user.slackTeamId}</td>
          <td>{user.slackId}</td>
          <td>
            <UserStatus user={user} />
          </td>
        </tr>
      </>
    );
  }
}

const SlackUserRow = ({ user }) => {
  const { profile } = useProfile();

  return (
    <UserRowContext
      user={user}
      profile={profile}
    />
  );
};

export default SlackUserRow;
